import { render, staticRenderFns } from "./CadastroConfiguracaoMeioPagamento.vue?vue&type=template&id=260cefa6"
import script from "./CadastroConfiguracaoMeioPagamento.vue?vue&type=script&lang=js"
export * from "./CadastroConfiguracaoMeioPagamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports